import { render } from "./DeliveryInfoDialog.vue?vue&type=template&id=cd0cac4c"
import script from "./DeliveryInfoDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryInfoDialog.vue?vue&type=script&lang=js"

import "./DeliveryInfoDialog.vue?vue&type=style&index=0&id=cd0cac4c&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__